"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var useStatusClass_1 = __importDefault(require("./useStatusClass"));
var types_1 = require("../../types");
var useStyles = styles_1.makeStyles({
    root: {
        border: 0,
        color: 'black',
        height: '100%',
        padding: 0,
        paddingLeft: '1%',
        width: '100%',
    },
});
// TODO Handle partial dates, e.g. when user is typing into date input
var DocumentPageDateInput = function (_a) {
    var onChange = _a.onChange, onFocus = _a.onFocus, input = _a.input;
    var id = input.id, status = input.status, value = input.value;
    var isDisabled = status === types_1.PageInputStatus.Disabled;
    var classes = useStyles();
    var statusClass = useStatusClass_1.default(status);
    var className = statusClass + " " + classes.root;
    var handleChange = function (value) {
        if (!value) {
            onChange(null);
            return;
        }
        var dateValue = date_fns_1.parseISO(value);
        onChange(dateValue);
    };
    return isDisabled ? (react_1.default.createElement("div", { className: className }, value ? date_fns_1.format(value, 'P') : '' // P means localized short date
    )) : (react_1.default.createElement("input", { type: "date", className: className, "data-tid": "DocumentPageDateInput-input-" + id, onChange: function (e) { return handleChange(e.target.value); }, onFocus: function () { return onFocus(); }, value: value ? date_fns_1.formatISO(value, { representation: 'date' }) : '' }));
};
exports.default = DocumentPageDateInput;
//# sourceMappingURL=DocumentPageDateInput.js.map